{
  "customer-register-dialog": {
    "buttons": {
      "cancel": "Cancel",
      "next": "Next"
    },
    "text": {
      "book_as_guest": "Book as a guest",
      "login": "log in",
      "or": " or ",
      "register": "register",
      "to_manage": "To manage all your bookings and favorite salons, please "
    }
  }
}
